import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=6b866449&scoped=true"
import script from "./ViewProduct.vue?vue&type=script&lang=ts"
export * from "./ViewProduct.vue?vue&type=script&lang=ts"
import style0 from "./ViewProduct.vue?vue&type=style&index=0&id=6b866449&prod&lang=scss&scoped=true"
import style1 from "./ViewProduct.vue?vue&type=style&index=1&id=6b866449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b866449",
  null
  
)

export default component.exports